// Kullanıcı bazlı prim ciro girişleri.
// Hook (useUserRevenueEntries) tarafından useDynamicEntity üzerinden çağrılır.

export const GET_USER_REVENUE_ENTRIES_QUERY = `
  query GetUserRevenueEntries(
    $where: user_revenue_entries_bool_exp = {}
    $limit: Int
    $offset: Int
  ) {
    user_revenue_entries_aggregate(where: $where) {
      aggregate { count }
    }
    user_revenue_entries(
      where: $where
      order_by: [{ yil: desc }, { ceyrek: desc }, { created_at: desc }]
      limit: $limit
      offset: $offset
    ) {
      id
      user_id
      company_id
      yil
      ceyrek
      ciro_kanali
      bonus_revenue_type_id
      firm_id
      contract_id
      job_id
      tutar
      ay_sayisi
      secili_aylar
      is_manual_amount
      toplam_ay
      aciklama
      status
      reject_reason
      created_at
      updated_at
      user { id first_name last_name team_id team { id name } }
      company { id name }
      firm {
        id
        firm_name
        firm_short_name
        is_established
        firm_carts {
          id
          firm_cart_firstname
          firm_cart_lastname
          firm_cart_mail
          firm_cart_phone
        }
      }
      contract {
        id
        # Sozlesme goruntule modali firma tam adini buradan okur.
        firm { id firm_name firm_short_name }
        # Satis cirosu ise degil sozlesmeye bagli; proje numarasi
        # sozlesmenin islerinden okunuyor (utils/revenueProjectNumber).
        # Durum + detay: satis cirosunda "sozlesmenin isleri kapandi mi"
        # uyarisi icin (utils/revenueWarnings entryClosure).
        jobs {
          id project_number job_status job_type teknopark_unit
          job_type_rel { id name is_project_based }
          job_details(order_by: { created_at: desc }) { detail_data }
        }
        pricing_method_id
        contract_signing_date
        protocol_start_date
        protocol_end_date
        work_start_date
        # Sozlesme geldi mi? DIKKAT: alan adi anlaminin TERSI —
        # true = "Geldi", false = "Gelmedi" (bkz. useContracts.js
        # transformData). Uyari motoru (revenueWarnings sozlesme_yok)
        # bu alana bakar; onceden fetch edilmedigi icin "sozlesme
        # gelmedi" olan sozlesmelerde uyari hic cikmiyordu.
        work_started_without_contract
        contract_subject { id name }
        scope_of_work { id name }
        renewals { id renewal_start_date renewal_end_date new_monthly_amount }
        invoices(order_by: { created_at: asc }) {
          id
          total_unit_price
          created_at
        }
        invoices_aggregate {
          aggregate {
            count
            sum { total_unit_price }
          }
        }
      }
      job {
        id
        contract_id
        job_title
        job_type
        job_type_id
        # Yeni dinamik job_types sistemine gecisten sonra jobs.job_type
        # (text) NULL olabiliyor — is turu ismini job_type_rel.name'den
        # cekmek gerekiyor. Onceden fetch edilmiyordu ve tabloda "Is Turu"
        # kolonu bazi satirlarda bos goruluyordu.
        # is_project_based: 'uzatma donemi' uyarisi yalnizca proje bazli
        # turlerde (TUBITAK/ULUSLARARASI/DIGER) anlamli.
        job_type_rel { id name is_project_based }
        project_number
        teknopark_unit
        project_extensions
        job_status
        updated_at
        job_assignment { technical_team_id financial_team_id }
        contract {
          id
          pricing_method_id
          contract_signing_date
          work_start_date
          # true = "Geldi", false = "Gelmedi" (ters isimlendirme).
          work_started_without_contract
          contract_description
          pricing_method { id name }
          contract_subject { id name }
          firm { id firm_name firm_short_name }
          renewals { id renewal_start_date renewal_end_date new_monthly_amount }
          invoices(order_by: { created_at: asc }) {
            id
            total_unit_price
            created_at
            payment_schedules
          }
          invoices_aggregate {
            aggregate { count sum { total_unit_price } }
          }
        }
        # user eklendi: ayni Gecmis tablosu Ciro Talepleri ekranindan
        # da aciliyor ve "Islem Yapan" sutunu bos kaliyordu.
        job_details(order_by: { created_at: desc }) {
          id
          job_detail_type
          detail_data
          created_at
          user { first_name last_name }
        }
      }
    }
  }
`;

// Firma seçimi için (kullanıcının erişebildiği firmalar).
// useFirms zaten frontend tarafında erişim filtrelemesini yapıyor; modal o hook'u kullanır.

// Sözleşme dropdown'u: firma seçildikten sonra çağrılır.
export const GET_CONTRACTS_BY_FIRM_QUERY = `
  query GetContractsByFirm($firmId: Int!) {
    contracts(
      where: { firm_id: { _eq: $firmId } }
      order_by: [{ contract_signing_date: desc_nulls_last }, { created_at: desc }]
    ) {
      id
      firm_id
      contract_signing_date
      contract_subject { id name }
      scope_of_work { id name }
      work_status { id name }
    }
  }
`;

// İş dropdown'u: firma seçildikten sonra çağrılır.
export const GET_JOBS_BY_FIRM_QUERY = `
  query GetJobsByFirm($firmId: Int!) {
    jobs(
      where: { firm_id: { _eq: $firmId } }
      order_by: [{ created_at: desc }]
    ) {
      id
      firm_id
      job_title
      job_type
      job_type_id
      job_type_rel { id name is_project_based }
      job_status
      project_number
      created_at
    }
  }
`;

// Ciro Aktar sayfasi icin aktarilabilir (onayli + satis disi) kayitlar.
// transfer_logs nested: kim/ne zaman/nereden-nereye audit trail.
// TEAM_MANAGER scope'unu where clause icinde sayfa derler (kendi ekibi).
// ROOT/DIRECTOR: Hasura policy company-scope filtreliyor.
export const GET_TRANSFERABLE_REVENUE_ENTRIES_QUERY = `
  query GetTransferableRevenueEntries($where: user_revenue_entries_bool_exp!) {
    user_revenue_entries(
      where: $where
      order_by: [{ yil: desc }, { ceyrek: asc }, { created_at: desc }]
    ) {
      id
      user_id
      yil
      ceyrek
      ciro_kanali
      bonus_revenue_type_id
      firm_id
      contract_id
      job_id
      tutar
      is_manual_amount
      toplam_ay
      aciklama
      user { id first_name last_name team_id team { id name } }
      firm { id firm_name firm_short_name }
      job { id job_title project_number }
      transfer_logs(order_by: { transferred_at: asc }) {
        id
        from_year
        from_quarter
        to_year
        to_quarter
        transferred_at
        note
        transferred_by_user { id first_name last_name }
      }
    }
  }
`;
